// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-article-inline__img[data-v-0132b488]{max-width:101px!important}@media screen and (min-width:600px){.k-article-inline__img[data-v-0132b488]{max-width:163px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
